
import { ArrowLeft, ArrowRight } from "lucide-react";

interface SessionDialogArrowsProps {
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

export function SessionDialogArrows({
  canGoPrev,
  canGoNext,
  onPrev,
  onNext,
}: SessionDialogArrowsProps) {
  return (
    <>
      <button
        aria-label="Previous session"
        onClick={onPrev}
        disabled={!canGoPrev}
        className="p-2 bg-background border rounded-full shadow hover:bg-accent transition-colors disabled:opacity-50 disabled:bg-muted disabled:cursor-default"
        style={{ pointerEvents: canGoPrev ? "auto" : "none" }}
        tabIndex={canGoPrev ? 0 : -1}
        type="button"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      
      <button
        aria-label="Next session"
        onClick={onNext}
        disabled={!canGoNext}
        className="p-2 bg-background border rounded-full shadow hover:bg-accent transition-colors disabled:opacity-50 disabled:bg-muted disabled:cursor-default"
        style={{ pointerEvents: canGoNext ? "auto" : "none" }}
        tabIndex={canGoNext ? 0 : -1}
        type="button"
      >
        <ArrowRight className="w-5 h-5" />
      </button>
    </>
  );
}
